module.exports = __webpack_public_path__ + "img/driver-v3-ios.9fa48f9e.png";